// 将卡号每隔4位加上一个空格
export const formatCardNo = card => {
  return card
    .replace(/\s/g, '')
    .replace(/[^\d]/g, '')
    .replace(/(\d{4})(?=\d)/g, '$1 ');
};

// 移除卡号的空格
export const resetCardNo = card => {
  return card.replace(/\s+/g, '');
};

// 数字类型
export const checkNumber = value => {
  const reg = /^-?([0-9][0-9]*)(\.[0-9]*)?$/;
  return reg.test(value.toString());
};
